/**
 * `fileName` only takes effect for same-origin, `blob:` and `data:` URLs.
 * For cross-origin URLs (S3) browsers ignore the `download` attribute: the
 * saved name comes from the response `Content-Disposition` header, else from
 * the last URL path segment. Without `Content-Disposition: attachment` a PDF
 * or image opens inline instead of downloading — that header is the backend's job.
 */
export const downloadFile = (path: string, fileName?: string) => {
  const anchor = document.createElement('a');
  anchor.href = path;
  anchor.download = fileName ?? '';

  document.body.appendChild(anchor);

  anchor.click();

  document.body.removeChild(anchor);
};
